export const SEARCH_MEMBER_ID_ELIGIBILITY = "/search/account/memberIdEligibility?id=";
export const MEMBER_DELETE_ACCOUNT = "/members/deleteAccount?";
export const MEMBER_UPDATE_CACHE = "/members/updateCache?uuid=";
export const ADD_ELIGIBILITY = "/members/addEligibility";
export const ADD_SDK_ELIGIBILITY = "/member/eligibilities/v2.0";
export const ADD_PE_ELIGIBILITY = "/member/eligibilities/v3.0";

export const REBUILD_CACHE_SDK = "/member/eligibilities/v1.0/status";
export const REBUILD_CACHE_NON_SDK = "/members/cache/rebuild";

export const UNLOCK_USER = "/members/unlockUser"
export const UNLOCK_RBA = "/members/unlockRba";

export const ENABLE_USER = "/members/esso/enableNew";
export const DISABLE_USER = "/members/esso/disableNew";

export const RESET_PASSWORD = "/members/resetPassword";
export const ACCOUNT_RECOVERY = "/members/account/recovery";

export const VERIFY_PHONE_EMAIL = "/members/verify/phone/email";
export const GENERATE_SMS_OTP = "/members/otp/sms";

export const GENERATE_EMAIL_OTP = "/members/otp/email"

export const VERIFY_EMAIL_OTP = "/members/otp/email/verifyToken";

export const VERIFY_SMS_OTP = "/members/otp/verifyToken";
export const DELETE_ELIGIBILITY = "/members/deleteEligibility";

export const BULK_DISABLE = "/upload";
export const BULK_LDAP_UNLOCK = "/ldap/unlock";
export const FETCH_PORTAL_CONFIG = "/config/portalConfig";

export const FETCH_ELIGIBILITY_PORTALS = "/screens/AddEligibility/";
export const FETCH_ELIGIBILITY_PORTAL_INFO = "/portals/";

export const FETCH_FARO_ID = "/members/external";
export const FETCH_GROUP_ID = "/members/fetch/groupId";

export const MEMBER_ACCOUNT = "/members/memberAccount";
export const ACCOUNT_ADMIN_ENABLED_PORTALS = "/screens/AccountAdmin/enabledPortals";

export const FETCH_AGENT_ACTIVITY_SEARCH_RESULT = "/activity/search";
export const FETCH_REPORT_SEARCH_RESULT = "/activity/event/stats";